import chroma from 'chroma-js';
import { ColorScale } from '../types/app.types';

const Classic : ColorScale = {
  name: 'Classic Iris',
  steps: [
    {
      color: chroma('#003CFF').rgba(),
      threshold: 2,
    },
    {
      color: chroma('#00C7C7').rgba(),
      threshold: 7,
    },
    {
      color: chroma('#00A8AC').rgba(),
      threshold: 12,
    },
    {
      color: chroma('#008261').rgba(),
      threshold: 18,
    },
    {
      color: chroma('#009637').rgba(),
      threshold: 21,
    },
    {
      color: chroma('#00C027').rgba(),
      threshold: 23,
    },
    {
      color: chroma('#00E80A').rgba(),
      threshold: 28,
    },
    {
      color: chroma('#24FF24').rgba(),
      threshold: 34,
    },
    {
      color: chroma('#FFFF1E').rgba(),
      threshold: 37,
    },
    {
      color: chroma('#FFE600').rgba(),
      threshold: 39,
    },
    {
      color: chroma('#FFBC00').rgba(),
      threshold: 44,
    },
    {
      color: chroma('#FF9800').rgba(),
      threshold: 50,
    },
    {
      color: chroma('#F20F00').rgba(),
      threshold: 53,
    },
    {
      color: chroma('#008261').rgba(),
      threshold: 55,
    },
    {
      color: chroma('#BB003A').rgba(),
      threshold: 60,
    },
    {
      color: chroma('#FF00FF').rgba(),
      threshold: 66,
    },
    {
      color: chroma('#FF00FF').rgba(),
      threshold: 72,
    },
  ],
};

export default Classic;
